import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'rsm',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const storageKey = 'area-managers-r-monthly-plans'

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem(storageKey, {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      search: filter.search,
      schedule: filter.schedule,
      area: filter.area,
      areaManager: filter.areaManager
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem(storageKey)
}

export {
  setTableOptions,
  getTableOptions
}
